import { 
  WagmiConfig, 
  createClient, 
  defaultChains, 
  configureChains,
  createStorage
} from "wagmi";
import { infuraProvider } from 'wagmi/providers/infura';
import { publicProvider } from 'wagmi/providers/public';
import { ConnectKitProvider, ConnectKitButton, getDefaultClient } from "connectkit"; 
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
// import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

import Home from "./components/Home";
import Footer from "./components/Footer";
import Dapp from "./components/Dapp";
import Arcade from "./components/Arcade";
import "./styles/Home.css";


// import Dashboard from "./components/Dashboard/Dashboard";
// import {ConnectWallet} from "./components/Global/ConnectWallet";


const infuraId = process.env.REACT_APP_INFURA_API_KEY;
// Configure chains & providers with the Alchemy provider.
// Two popular providers are Alchemy (alchemy.com) and Infura (infura.io)
const { 
  chains, 
  provider, 
  webSocketProvider 
} = configureChains(defaultChains, [
  infuraProvider({ apiKey: infuraId }),
  publicProvider(),
])
 
// Set up client
const client = createClient({
  appName: "Quantum Energy",
  autoConnect: true,
  connectors: [
    new MetaMaskConnector({ 
      chains,
      options: {
        // This is the default, but you can change it if you want.
        // See https://docs.metamask.io/guide/ethereum-provider.html#ethereum-autorefreshonnetworkchange
        shouldAutoRefreshOnNetworkChange: true,
        appName: "Quantum Energy",
      },
  
     }),
    new CoinbaseWalletConnector({
      chains,
      options: {
        appName: 'wagmi',
      },
    }),
    new WalletConnectConnector({
      chains,
      options: {
        qrcode: true,
      },
    }),
    new InjectedConnector({
      chains,
      options: {
        name: 'Injected',
        shimDisconnect: true,
      },
    }),
  ],
  provider,
  storage: createStorage({ storage: window.localStorage }),
  webSocketProvider,
})

const App = () => {
  return (
    <WagmiConfig client={client}>
      <ConnectKitProvider theme="default" mode="dark">   
      <Router>
      <Route path="/" exact>
        <Home />
      </Route>
      <Route path="/dashboard" exact>
        <Dapp />
      </Route>
      <Route path="/arcade" exact>
        <Arcade />
      </Route>
      <Footer />
    </Router>
    </ConnectKitProvider>
    </WagmiConfig>
  );
};

export default App;
